/**
 * Generated bundle index. Do not edit.
 */

export {NotaAlunoModuloModule,ConsultaComponent,ConsultaPosComponent,NotfoundComponent,ConsultaMedicinaComponent,BloqueadoColegioComponent,CarregandoComponent,NotaInicioComponent,ConsultaColegioComponent} from './index';

export {routes as ɵa} from './src/app/app.routing';
export {ConsultaColegioService as ɵh} from './src/app/providers/service/colegio/consulta-colegio.service';
export {ConsultaMedicinaService as ɵi} from './src/app/providers/service/medicina/consulta-medicina.service';
export {ConsultaPosService as ɵg} from './src/app/providers/service/pos/consulta-pos.service';
export {ConsultaTradicionalService as ɵb} from './src/app/providers/service/tradicional/consulta-tradicional.service';
export {BaseService as ɵc} from './src/app/providers/util/BaseService';
export {RESTClientService as ɵf} from './src/app/providers/util/RESTClientService';
export {MensagemUtil as ɵd} from './src/app/providers/util/notificacao/mensagemUtil';
export {NotificacaoComponent as ɵj} from './src/app/providers/util/notificacao/notificacao.component';
export {NotificacaoService as ɵe} from './src/app/providers/util/notificacao/notificacao.service';